import type { TownsquareProjectUpdate } from '../../types';

export const isTownsquareProjectUpdate = (entity: any): entity is TownsquareProjectUpdate =>
	entity.__typename === 'TownsquareProjectUpdate';

export const getTownsquareProjectUpdateLink = (update: TownsquareProjectUpdate): string | null =>
	update?.url ?? null;
